/**
 * Group used to scope cluster options in the records cluster assignment modal.
 */
export const CLUSTER_ASSIGNMENT_OPTIONS_GROUP_ID =
  'SpaceRecords.ClusterAssignment.Options'
